"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOffsetFromTimeZone = void 0;
const getOffsetFromTimeZone = (timeZone) => {
    const parts = new Intl.DateTimeFormat('en-US', {
        timeZone,
        timeZoneName: 'shortOffset',
    }).formatToParts(new Date());
    const tzPart = parts.find((p) => p.type === 'timeZoneName');
    const value = tzPart === null || tzPart === void 0 ? void 0 : tzPart.value;
    if (value && value === 'GMT')
        return 0;
    return value ? parseInt(value.replace('GMT', '')) : undefined;
};
exports.getOffsetFromTimeZone = getOffsetFromTimeZone;
